var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1690726106763,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 16360,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M451.567213 528.786885h171.22623v100.721312H451.567213z",
    fill: "#546E7A",
    "p-id": 16361
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144.367213 394.491803m-67.147541 0a67.147541 67.147541 0 1 0 134.295082 0 67.147541 67.147541 0 1 0-134.295082 0Z",
    fill: "#CFD8DC",
    "p-id": 16362
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M664.760656 1015.606557H35.252459v-184.655737c0-110.793443 90.64918-201.442623 201.442623-201.442623h226.622951c110.793443 0 201.442623 90.64918 201.442623 201.442623v184.655737z",
    fill: "#13227a",
    "p-id": 16363,
    "data-spm-anchor-id": "a313x.7781069.0.i34",
    className: "selected"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M765.481967 1015.606557H135.97377v-184.655737c0-110.793443 90.64918-201.442623 201.442623-201.442623h226.622951c110.793443 0 201.442623 90.64918 201.442623 201.442623v184.655737z",
    fill: "#11b4da",
    "p-id": 16364,
    "data-spm-anchor-id": "a313x.7781069.0.i32",
    className: ""
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M780.590164 726.872131l33.57377 70.504918c1.678689 5.036066 6.714754 8.393443 13.429509 10.072131l75.540983 11.75082c13.429508 1.678689 18.465574 18.465574 10.072131 28.537705L856.131148 903.134426c-3.357377 3.357377-5.036066 8.393443-5.036066 15.108197l13.429508 78.898361c1.678689 13.429508-11.75082 23.501639-25.180328 16.786885l-65.468852-36.931148c-5.036066-3.357377-11.75082-3.357377-16.786885 0l-65.468853 36.931148c-11.75082 6.714754-26.859016-3.357377-25.180328-16.786885l13.429508-78.898361c1.678689-5.036066 0-10.072131-5.036065-15.108197L621.114754 846.059016c-10.072131-10.072131-3.357377-26.859016 10.072131-28.537705L705.04918 805.770492c5.036066-1.678689 10.072131-5.036066 13.429509-10.072131l33.57377-70.504918c5.036066-11.75082 23.501639-11.75082 28.537705 1.678688z",
    fill: "#FFA726",
    "p-id": 16365,
    "data-spm-anchor-id": "a313x.7781069.0.i36",
    className: ""
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M913.206557 553.967213l18.465574 38.609836c1.678689 3.357377 3.357377 5.036066 6.714754 5.036066l41.967213 6.714754c8.393443 1.678689 10.072131 10.072131 5.036066 15.108197l-30.216394 31.895082c-1.678689 1.678689-3.357377 5.036066-3.357377 8.393442l6.714755 43.645902c1.678689 8.393443-6.714754 13.429508-13.429509 10.072131l-36.931147-20.144262c-3.357377-1.678689-6.714754-1.678689-8.393443 0l-36.931147 20.144262c-6.714754 3.357377-15.108197-1.678689-13.429509-10.072131l6.714755-43.645902c0-3.357377 0-6.714754-3.357378-8.393442L822.557377 621.114754c-5.036066-5.036066-1.678689-15.108197 5.036066-15.108197l41.967213-6.714754c3.357377 0 5.036066-1.678689 6.714754-5.036065l18.465574-38.609836c3.357377-8.393443 15.108197-8.393443 18.465573-1.678689z",
    fill: "#FFA726",
    "p-id": 16366
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M488.498361 629.508197H312.236066c-92.327869 0-167.868852-75.540984-167.868853-167.868853v-285.377049h512v285.377049c0 92.327869-75.540984 167.868852-167.868852 167.868853z",
    fill: "#CFD8DC",
    "p-id": 16367
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M144.367213 176.262295h75.540984V318.95082H144.367213z",
    fill: "#455A64",
    "p-id": 16368
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M177.940984 528.786885h181.29836v100.721312H177.940984z",
    fill: "#455A64",
    "p-id": 16369
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M401.206557 1015.606557V822.557377l-41.967213-193.04918h184.655738L501.927869 822.557377v193.04918z",
    fill: "#CFD8DC",
    "p-id": 16370
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M656.367213 318.95082H144.367213",
    fill: "#546E7A",
    "p-id": 16371
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M345.809836 318.95082m-75.540984 0a75.540984 75.540984 0 1 0 151.081968 0 75.540984 75.540984 0 1 0-151.081968 0Z",
    fill: "#546E7A",
    "p-id": 16372
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M547.252459 318.95082m-75.540984 0a75.540984 75.540984 0 1 0 151.081968 0 75.540984 75.540984 0 1 0-151.081968 0Z",
    fill: "#546E7A",
    "p-id": 16373
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M740.301639 8.393443H295.44918c-83.934426 0-151.081967 67.147541-151.081967 151.081967v16.786885h512l83.934426-167.868852z",
    fill: "#546E7A",
    "p-id": 16374
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActor);
export default __webpack_public_path__ + "static/media/actor.fd39f345797a9dffec45f0c8c556892d.svg";
export { ForwardRef as ReactComponent };